"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _fonts = require("../../styles/fonts");
var _mixins = require("../../styles/mixins");
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _variables = require("../../styles/variables");
var _ArrowDown = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowDown8"));
var _animations = require("../../styles/animations");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBStatus = function HBStatus(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'neutral' : _ref$theme,
    type = _ref.type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'xs' : _ref$size,
    prefixIcon = _ref.prefixIcon,
    label = _ref.label,
    _ref$clickable = _ref.clickable,
    clickable = _ref$clickable === void 0 ? false : _ref$clickable,
    _ref$dropdown = _ref.dropdown,
    dropdown = _ref$dropdown === void 0 ? false : _ref$dropdown,
    _ref$maxTextWidth = _ref.maxTextWidth,
    maxTextWidth = _ref$maxTextWidth === void 0 ? '100px' : _ref$maxTextWidth,
    testId = _ref.testId,
    testIdName = _ref.testIdName;
  var PrefixIcon = prefixIcon;
  var SuffixIcon = dropdown ? _ArrowDown["default"] : undefined;
  var _clickable = clickable || dropdown;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'status',
    componentName: 'HBStatus'
  });
  return /*#__PURE__*/_react["default"].createElement(HBStatusWrapper, {
    theme: theme,
    type: type,
    size: size,
    clickable: _clickable,
    "data-testid": finalTestId
  }, type !== 'dot' && PrefixIcon && /*#__PURE__*/_react["default"].createElement(IconWrapper, null, /*#__PURE__*/_react["default"].createElement(PrefixIcon, null)), type === 'dot' ? /*#__PURE__*/_react["default"].createElement(Dot, {
    theme: theme,
    size: size
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, type === 'secondary' && /*#__PURE__*/_react["default"].createElement(Dot, {
    theme: theme,
    size: size
  }), /*#__PURE__*/_react["default"].createElement(TextWrapper, {
    size: size,
    type: type,
    clickable: _clickable,
    title: label,
    maxTextWidth: maxTextWidth
  }, label), SuffixIcon && /*#__PURE__*/_react["default"].createElement(SuffixIconWrapper, null, /*#__PURE__*/_react["default"].createElement(SuffixIcon, null))));
};
var _default = exports["default"] = HBStatus;
var STRUCTURE = {
  xs: {
    lineHeight: "".concat(_spacing["default"][16]),
    height: "".concat(_spacing["default"][16]),
    padding: "0 ".concat(_spacing["default"][6]),
    fontSize: _fonts.fontSizes.s10,
    dotSize: "".concat(_spacing["default"][4])
  },
  sm: {
    lineHeight: "".concat(_spacing["default"][24]),
    height: "".concat(_spacing["default"][24]),
    padding: "0 ".concat(_spacing["default"][8]),
    fontSize: _fonts.fontSizes.s14,
    dotSize: "".concat(_spacing["default"][6])
  }
};
var THEME = {
  neutral: {
    backgroundColor: _colors["default"].neutral200,
    textColor: _colors["default"].textSecondary,
    dotColor: _colors["default"].neutral600,
    iconColor: _colors["default"].neutral800
  },
  accent: {
    backgroundColor: _colors["default"].blue20_15,
    textColor: _colors["default"].blue30,
    dotColor: _colors["default"].blue20,
    iconColor: _colors["default"].lavender700
  },
  success: {
    backgroundColor: _colors["default"].green100,
    textColor: _colors["default"].green700,
    dotColor: _colors["default"].green600,
    iconColor: _colors["default"].green700
  },
  warning: {
    backgroundColor: _colors["default"].orange200,
    textColor: _colors["default"].orange700,
    dotColor: _colors["default"].orange500,
    iconColor: _colors["default"].orange700
  },
  danger: {
    backgroundColor: _colors["default"].red100,
    textColor: _colors["default"].red600,
    dotColor: _colors["default"].red500,
    iconColor: _colors["default"].red600
  }
};
var HBStatusWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBStatus__HBStatusWrapper",
  componentId: "sc-bog6xy-0"
})(["display:inline-flex;gap:", ";align-items:center;justify-content:center;height:", ";padding:", ";", " background-color:", ";", ";color:", ";position:relative;overflow:hidden;cursor:", ";width:fit-content;", " ", " &:hover{", " ", "}&:focus-visible{outline:3px solid ", ";border-radius:", ";offset:1px;}"], _spacing["default"][4], function (props) {
  return STRUCTURE[props.size || 'xs'].height;
}, function (props) {
  return props.type === 'dot' ? '0' : STRUCTURE[props.size || 'xs'].padding;
}, function (props) {
  return (props.type === 'primary' || props.type === 'secondary') && "border-radius: ".concat(_variables.cornerRadiusRound, ";");
}, function (props) {
  return props.type === 'primary' ? THEME[props.theme || 'neutral'].backgroundColor : 'transparent';
}, _mixins.proximaNova, function (props) {
  return THEME[props.theme || 'neutral'].textColor;
}, function (props) {
  return props.clickable ? 'pointer' : 'default';
}, function (props) {
  return (0, _mixins.setIconFillColor)(THEME[props.theme || 'neutral'].iconColor);
}, (0, _animations.transition)('background-color'), function (props) {
  return props.clickable && props.type === 'primary' && "\n            &::after {\n                content: '';\n                position: absolute;\n                inset: 0;\n                background-color: ".concat(_colors["default"].black_01, ";\n                pointer-events: none;\n            }\n        ");
}, function (props) {
  return props.clickable && props.type === 'secondary' && "\n            background-color: ".concat(_colors["default"].black_01, "\n        ");
}, _colors["default"].blue20, _variables.cornerRadiusRound);
var TextWrapper = _styledComponents["default"].span.withConfig({
  displayName: "HBStatus__TextWrapper",
  componentId: "sc-bog6xy-1"
})(["max-width:", ";font-size:", ";color:", ";position:relative;bottom:-0.03em;line-height:", ";overflow:hidden;white-space:nowrap;text-overflow:ellipsis;", ""], function (props) {
  return props.maxTextWidth;
}, function (props) {
  return STRUCTURE[props.size || 'xs'].fontSize;
}, function (props) {
  return props.type === 'secondary' ? _colors["default"].neutral900 : 'inherit';
}, function (props) {
  return STRUCTURE[props.size || 'xs'].lineHeight;
}, function (props) {
  return props.type === 'secondary' && props.clickable && (0, _styledComponents.css)(["text-decoration:underline;text-underline-offset:3px;text-decoration-color:", ";", ":hover &{text-decoration-color:", ";}"], _colors["default"].neutral500, HBStatusWrapper, _colors["default"].neutral600);
});
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBStatus__IconWrapper",
  componentId: "sc-bog6xy-2"
})(["margin-right:", ";"], _spacing["default"][2]);
var SuffixIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBStatus__SuffixIconWrapper",
  componentId: "sc-bog6xy-3"
})(["margin-left:", ";"], _spacing["default"][2]);
var Dot = _styledComponents["default"].div.withConfig({
  displayName: "HBStatus__Dot",
  componentId: "sc-bog6xy-4"
})(["width:", ";height:", ";border-radius:", ";background-color:", ";"], function (props) {
  return STRUCTURE[props.size].dotSize;
}, function (props) {
  return STRUCTURE[props.size].dotSize;
}, _variables.cornerRadiusRound, function (props) {
  return THEME[props.theme].dotColor;
});
//# sourceMappingURL=HBStatus.js.map